import React from "react";
import PropTypes from "prop-types";
import "./Searchbar.css";

const SearchBar = (props) => {
  return (
    <div className="Search">
      <input
        className="SearchInput"
        type="text"
        onChange={props.onChange}
        placeholder={props.placeholder}
      />
    </div>
  );
};

SearchBar.propTypes = {
  /**
   *  Function to run when onChange event is triggered
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Text placeholder for the search bar
   */
  placeholder: PropTypes.string.isRequired,
};

export default SearchBar;